export default "__VITE_ASSET__fknfYMBR__"